import { Component } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { RegulationAcceptanceDto } from '@models/regulation/regulation-acceptance.dto';
import { RegulationDto } from '@models/regulation/regulation.dto';
import { AccountService } from '@services/account.service';
import { MenuItem } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-regulation-dialog',
  templateUrl: './regulation-dialog.component.html',
  styleUrls: ['./regulation-dialog.component.scss'],
})
export class RegulationDialogComponent {
  public items: MenuItem[] = [];
  public formGroup: FormGroup;
  public selectedIndex: number = 0;
  public regulations: RegulationDto[] = [];
  public userRegulations: RegulationAcceptanceDto[] = [];

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private userService: AccountService,
  ) {
    this.regulations = config.data.regulations;
    this.items = this.regulations.map((elem: RegulationDto, index: number) => {
      this.userRegulations.push({
        acceptanceAnswer: '',
        user: userService.user!,
        original: elem,
      });
      return {};
    });
    this.items.push({});

    this.formGroup = new FormGroup(
      {
        acceptance: new FormControl(
          '',
          Validators.compose([Validators.required]),
        ),
      },
      [this.acceptanceConfirmation],
    );
  }

  acceptanceConfirmation: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    return this.regulations[this.selectedIndex].mandatoryAnswer ===
      this.userRegulations[this.selectedIndex].acceptanceAnswer
      ? null
      : { NotAccepted: true };
  };

  goForward() {
    this.selectedIndex = this.selectedIndex + 1;
  }

  goBack() {
    this.selectedIndex = this.selectedIndex - 1;
  }

  acceptRegulations() {
    this.ref.close(this.userRegulations);
  }
}
